import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { CategoriaAtendimentoService } from '../categoriaAtendimento.service'
import { ExibirMenuService } from '../../../shared/exibir-menu.service'
import { AcessoApiService } from '../../../../acessoApi.service'
import { DadosAcessoService } from '../../../../dadosAcesso.service'
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-editar-categoria',
  templateUrl: './editar-categoria.component.html',
  styleUrls: ['./editar-categoria.component.css']
})
export class EditarCategoriaComponent implements OnInit {

  public nivel_cat: number;
  public num_cat: number;
  public descricao_cat: string;
  public codCat: any
  public ordem_cat: number
  public id_cat: number
  public mensagem: any
  public niveis: any
  public pais: any
  public arrayInfos: any
  public id_cat_pai: number
  public CategoriasAtendimentosEditar: any = [{ id_cat: 0, num_cat: 0, descricao_cat: "",ordem_cat: 0,nivel_cat: 0, cat_pai: "" }]

  constructor(private notificacao: NotificationsService, private acessoAPI: AcessoApiService, private categoriaService: CategoriaAtendimentoService,private exibirItens: ExibirMenuService, private dadosAcesso: DadosAcessoService, private router: Router) { 
    if(sessionStorage.getItem('cod_loja') === null){

      this.router.navigate(["/"])
    }
    
  this.codCat = this.categoriaService.recuperarCodCat()

  this.acessoAPI.editarCategoria(this.codCat).subscribe(data => {

     this.id_cat = data[0].ID_CATE
     this.num_cat = data[0].NUMERO_CATE
     this.descricao_cat = data[0].DESCRICAO_CATE
     this.ordem_cat = data[0].ORDEM_CATE
     this.nivel_cat = data[0].NIVEL_CATE
     this.id_cat_pai = data[0].CATEGORIA_PAI_CATE
    
}, error =>{
       
})

  this.acessoAPI.getListaNiveis().subscribe(res =>{
    this.niveis = res
  })

  this.acessoAPI.getListaPais().subscribe(res =>{
    this.pais = res
  })  
    this.exibirItens.setItensVisiveis(true);


  }

  ngOnInit() {
  }

  RetornarCategoria(){
    this.router.navigate(["/administrativo/cate-atendimento"])
  }

  changeNivel(nivel){
    
    this.nivel_cat = parseInt(nivel.value);
 }

 changePai(pai){
   this.id_cat_pai = parseInt(pai.value)
 }



 getOrdem(ordem: Event): void{
  this.ordem_cat = parseInt(((<HTMLInputElement>ordem.target).value))
}


getDescricao(descricao: Event): void{
  this.descricao_cat = ((<HTMLInputElement>descricao.target).value)
}



 getNumero(numero: Event): void{
   this.num_cat = parseInt((<HTMLInputElement>numero.target).value);
 }



  SalvarNovaCategoria(){
    this.acessoAPI.EditarCategoria(this.id_cat, this.nivel_cat, this.num_cat,
       this.descricao_cat, this.ordem_cat,  this.id_cat_pai).subscribe(data =>{
        this.mensagem = data

        this.notificacao.success(
          'Solicitação enviada!',
          "Editada com sucesso!",
          {
            timeOut: 2000,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            maxLength: 2
          }
        )

        this.nivel_cat = 1, 
        this.num_cat = 0,
        this.descricao_cat = '',
        this.ordem_cat = 0, 
        this.id_cat_pai = 1100

       }, error=>{

        this.notificacao.error(
          'Solicitação não enviada!',
          error._body,
          {
            timeOut: 2000,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            maxLength: 2
          }
        )

       })
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/administracao/categoria-atendimento/editar-categoria/editar-categoria.component.ts